// Shared react-select styling so dropdowns match the app's dark theme
// (Bootstrap 4's default react-select styling is a white box, unreadable
// against the --mm- dark palette).
const darkSelectStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: 'var(--mm-bg)',
    borderColor: state.isFocused ? 'var(--mm-cyan)' : 'var(--mm-line)',
    boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(18,184,178,0.25)' : 'none',
    minHeight: '38px',
    '&:hover': { borderColor: 'var(--mm-cyan)' },
  }),
  menu: (base) => ({ ...base, backgroundColor: 'var(--mm-panel-2)', border: '1px solid var(--mm-line)', zIndex: 20 }),
  menuList: (base) => ({ ...base, padding: 0 }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? 'var(--mm-cyan-dim)' : 'transparent',
    color: state.isFocused ? 'var(--mm-cyan)' : 'var(--mm-text)',
    cursor: 'pointer',
  }),
  singleValue: (base) => ({ ...base, color: 'var(--mm-text)' }),
  input: (base) => ({ ...base, color: 'var(--mm-text)' }),
  placeholder: (base) => ({ ...base, color: 'var(--mm-muted)' }),
  indicatorSeparator: (base) => ({ ...base, backgroundColor: 'var(--mm-line)' }),
  dropdownIndicator: (base) => ({ ...base, color: 'var(--mm-muted)' }),
  clearIndicator: (base) => ({ ...base, color: 'var(--mm-muted)' }),
};

export default darkSelectStyles;
